// Update the media library pagination
function updateMediaLibraryPagination(data) {
  // Target
  var target = $('.pagination__wrapper--media-library');

  // console.log(data);

  data.page = parseInt(data.page);
  data.pages = parseInt(data.pages);

  // Reset container
  target.html('');

  // Abort if there is only one page
  if (data.pages <= 1) {
    return '';
  }

  var pointerLeft =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"/></svg>';
  var pointerRight =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"/></svg>';

  // Wrapper
  var wrapper = $('<ul class="pagination__wrapper"/>');

  // Link left
  wrapper.append(
    getMediaLibraryPaginationLink(
      data.page,
      data.page - 1,
      data.page <= 1,
      pointerLeft
    )
  );

  // Link number left
  wrapper.append(getMediaLibraryPaginationLink(data.page, 1));

  // Form
  if (data.pages > 4) {
    var textFieldHasCurrentPage = data.page != 1 && data.page != data.pages;

    var paginationForm = $(
      '<input class="textfield pagination__textfield" type="number" placeholder="Seite" maxlength="4"/>'
    );
    if (textFieldHasCurrentPage) {
      paginationForm.addClass('pagination__textfield--active');
    }
    paginationForm.val(textFieldHasCurrentPage ? data.page : '');
    paginationForm.on('keypress', function (ev) {
      if (ev.which == 13) {
        if ($(this).val()) {
          requestMediaLibraryData($(this).val());
        }
      }
    });
    wrapper.append(paginationForm);
  } else if (data.pages > 1) {
    // No form, then show page links
    if (data.pages > 1) {
      wrapper.append(getMediaLibraryPaginationLink(data.page, 2));
    }
    if (data.pages > 2) {
      wrapper.append(getMediaLibraryPaginationLink(data.page, 3));
    }
  }

  // Link number right
  if (data.pages > 3) {
    wrapper.append(getMediaLibraryPaginationLink(data.page, data.pages));
  }

  // Link right
  wrapper.append(
    getMediaLibraryPaginationLink(
      data.page,
      data.page + 1,
      data.page >= data.pages,
      pointerRight
    )
  );

  // Append
  wrapper.appendTo('.media-library__wrapper .list-options__wrapper--top .pagination__wrapper--media-library');
  wrapper.clone(true).appendTo('.media-library__wrapper .list-options__wrapper--bottom .pagination__wrapper--media-library');
}

// Get the media library pagination link
function getMediaLibraryPaginationLink(page, toPage, disabled, pointer) {
  // Container
  var container = $('<li class="pagination__link"/>');
  if (disabled) {
    container.addClass('pagination__link--disabled');
  } else if (page == toPage) {
    container.addClass('pagination__link--active');
  }

  // Link
  var link = $('<span/>');
  if (pointer) {
    link.addClass('pagination__pointer icon-link');
  }
  link.html(pointer ? pointer : toPage);
  link.on('click', function () {
    !disabled && requestMediaLibraryData(toPage);
  });
  link.appendTo(container);

  return container;
}
